import React from 'react';

import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import { LinkProps } from '../../blocks/editorial-full-width-text-and-image-block/editorial-full-width-text-and-image-block';
import Image from 'next/image';
import LinkWrapper from '@/components/link-wrapper/link-wrapper';

export interface FullWidthImageBlockProps extends LinkProps {
  landscapeImageWrapper?: {
    jsonBynderAsset: {
      originalUrl: string;
    };
    altText?: string;
  };
  portraitImageWrapper?: {
    jsonBynderAsset: {
      originalUrl: string;
    };
    altText?: string;
  };
  imageAlignment?: string;
  topBlock?: boolean;
  smallBlock?: boolean;
  cardType?: string;
}

const EditorialPageFullWidthImageWrapper = ({
  landscapeImageWrapper,
  portraitImageWrapper,
  imageAlignment,
  cardType,
  children,
  cardLink,
  externalLink,
  topBlock,
}: React.PropsWithChildren & FullWidthImageBlockProps) => {
  const hoverCss =
    'relative after:z-50 transform-gpu after:transition-all after:duration-200 after:ease-in-out after:absolute after:top-0 after:left-0 after:h-full after:w-full after:rounded-card-t-mobile after:bg-transparency-backdrop after:opacity-0';

  const imageAlignmentCss =
    cardType === 'Default' && imageAlignment === 'Right'
      ? 'flex-col sm:flex-row-reverse '
      : cardType === 'Default' && imageAlignment === 'Left'
        ? 'flex-col sm:flex-row '
        : cardType === 'Default' && !imageAlignment
          ? 'flex-col sm:flex-row '
          : cardType !== 'Default'
            ? 'flex-col '
            : '';

  const imageCss =
    'sm:rounded-card-mobile h-full w-full object-cover self-stretch transform-gpu  ' +
    (landscapeImageWrapper
      ? 'aspect-1.5/1 max-h-[430px]  '
      : portraitImageWrapper
        ? 'aspect-1/0.75 max-h-[860px]  '
        : ' ') +
    (cardType === 'Carousel item'
      ? 'rounded-t-card-mobile sm:h-full '
      : 'rounded-card-mobile ');
  const image: any = landscapeImageWrapper?.jsonBynderAsset?.originalUrl
    ? landscapeImageWrapper?.jsonBynderAsset?.originalUrl
    : portraitImageWrapper?.jsonBynderAsset?.originalUrl
      ? portraitImageWrapper?.jsonBynderAsset?.originalUrl
      : null;

  const altText =
    landscapeImageWrapper?.altText ||
    portraitImageWrapper?.altText ||
    'alt text not found';

  const Layout = () => {
    return (
      <div
        className={
          'mx-auto flex items-start gap-0 sm:gap-4 sm:px-0  ' +
          (cardType === 'Carousel item'
            ? 'mx-0 h-full w-[300px] flex-1 sm:w-full '
            : ' ') +
          (cardType === 'Column item' ? 'mx-0 w-full ' : ' ') +
          (cardType === 'Default' && topBlock ? 'pt-0 sm:pt-5 lg:pt-0 ' : ' ') +
          imageAlignmentCss
        }
      >
        <div
          className={
            'w-full flex-1 transform-gpu rounded-t-card-mobile bg-background-primary-light sm:rounded-card-mobile sm:px-0 sm:pt-0 ' +
            (cardType === 'Carousel item'
              ? ' '
              : cardType === 'Column item' && topBlock
                ? 'px-5 '
                : cardType === 'Column item'
                  ? 'flex-none px-5 pt-5 sm:pt-0 '
                  : 'px-5 pt-5  sm:pt-0 ') +
            ((cardType === 'Default' || cardType === 'Column item') && topBlock
              ? 'rounded-none rounded-t-none sm:rounded-b-card-mobile '
              : ' ')
          }
        >
          <img
            alt={altText}
            src={image}
            className={
              imageCss +
              (externalLink || cardLink
                ? hoverCss + ' lg:group-hover:after:opacity-100 '
                : ' ')
            }
            // height={1000}
            // width={1500}
            // unoptimized={image?.includes('brandportal.ingkacentres.com')}
          />
        </div>
        {children}
      </div>
    );
  };

  const Container = () => {
    return (
      <>
        {cardLink &&
        !externalLink &&
        (cardType === 'Carousel item' || cardType === 'Column item') ? (
          <LinkWrapper
            className={
              'group cursor-pointer' +
              (cardType === 'Carousel item'
                ? 'mx-0 h-full w-[300px] flex-1 sm:w-full '
                : ' ')
            }
            data={cardLink}
          >
            <Layout />
          </LinkWrapper>
        ) : ((!cardLink && externalLink) || (cardLink && externalLink)) &&
          (cardType === 'Carousel item' || cardType === 'Column item') ? (
          <a
            className={
              'group cursor-pointer ' +
              (cardType === 'Carousel item'
                ? 'mx-0 h-full w-[300px] flex-1  sm:w-full '
                : ' ')
            }
            target={'_blank'}
            rel={'noopener noreferrer'}
            href={externalLink}
          >
            <Layout />
          </a>
        ) : (!cardLink && !externalLink) ||
          (cardType !== 'Carousel item' && cardType !== 'Column item') ? (
          <Layout />
        ) : null}
      </>
    );
  };

  return <Container />;
};

export default EditorialPageFullWidthImageWrapper;
